import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { SidenavService } from '../../services/sidenav.service';
import { LanguageService } from '../../services/language.service';
import { UsersManagementService } from '../../services/usersManagement.service';
import { AuthGuard } from '../../services/auth.guard';
import { AuthService } from '../../services/auth.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { GenericDialogComponent } from '../../generic-dialog/generic-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from '../../security/permission';


@Component({
  standalone: false,
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  animations: [
    trigger('slideToggle', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
})
export class SidenavComponent implements OnInit {

  Permission = Permission;
  language: any;
  variables: any;
  openDiv: boolean = false;
  openDivManagement: boolean = false;
  openDivCatalogs: boolean = false;
  isOpen: boolean = false;
  shouldPinSidenav: boolean = false;
  onProjectPage: boolean = false;
  // isAdmin: boolean = false;
  isDropdownOpen: boolean = false;
  selectedLanguage: string = 'es';

  @Input() menuOpen: boolean = false;

  @Output() open: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private sidenavService: SidenavService,
    private dialog: MatDialog,
    public authservice: AuthService,
    private router: Router,
    private authService: AuthGuard,
    private languageService: LanguageService,
    private UsersManagementService: UsersManagementService,
    private dataService: DataService,
  ) {
    this.router.url === '/projecto' ? (this.onProjectPage = true) : (this.onProjectPage = false);
  }

  ngOnInit() {
    if (!sessionStorage.getItem('language')) {
      sessionStorage.setItem('language', 'es');
    }
    const storedLanguage = sessionStorage.getItem('language');
    this.selectedLanguage = storedLanguage ? storedLanguage : 'es';

    this.languageService.language$.subscribe((language: string) => {
      this.selectedLanguage = language;
    });
    this.languageService.translations$.subscribe((data: any) => {
      this.variables = data;
    });
  }

  ngAfterViewInit() {
    this.sidenavService.sideNavState$.subscribe((data) => {
      this.isOpen = data;
      this.syncIconOnlyModeTransition();
    });

    this.sidenavService.shouldPinSidenavState.subscribe((data) => {
      this.shouldPinSidenav = data;
      this.syncIconOnlyModeTransition();
    });
  }

  navigateToProjects() {
    this.dataService.clearProjectsFilter();
    this.router.navigate(['/projectos']);
  }

  // Emit to parent that the sidenav is open
  openSidenav() {
    this.isOpen = !this.isOpen;
    this.open.emit(this.isOpen);
  }

  logout() {
    this.authService.logOut();
  }

  changeLanguage(lang: string) {

    let local_data = {
      message: this.variables.sureLanguageChange
    }

    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: local_data
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.data) {
        this.languageService.language = lang;
        location.reload();
      }
    });
  }

  actionDiv(s: boolean) {
    if (this.isIconOnlyMode()) {
      return;
    }
    this.openDiv = !this.openDiv;
  }

  actionDivManagement(s: boolean) {
    if (this.isIconOnlyMode()) {
      return;
    }
    this.openDivManagement = !this.openDivManagement;
  }

  actionDivCatalogs(s: boolean) {
    if (this.isIconOnlyMode()) {
      return;
    }
    this.openDivCatalogs = !this.openDivCatalogs;
  }

  private syncIconOnlyModeTransition() {
    if (this.isIconOnlyMode()) {
      this.openDiv = false;
      this.openDivManagement = false;
      this.openDivCatalogs = false;
    }
  }

  private isIconOnlyMode(): boolean {
    return !this.isOpen && !this.shouldPinSidenav;
  }

}
